import { render, staticRenderFns } from "./AddWavegateway.vue?vue&type=template&id=042293a4&scoped=true&"
import script from "./AddWavegateway.vue?vue&type=script&lang=ts&"
export * from "./AddWavegateway.vue?vue&type=script&lang=ts&"
import style0 from "./AddWavegateway.vue?vue&type=style&index=0&id=042293a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042293a4",
  null
  
)

export default component.exports